import { useEffect } from 'react';
import { getEnvKey, loadCss } from '../utils';
import { useLoaderScript } from './useScript';
const _cssUrl = 'http://api.map.baidu.com/res/webgl/10/bmap.css';
export function useLoaderBMap({ url, cssUrl, mode, authLoginType, }) {
    const { status, setSrc } = useLoaderScript();
    useEffect(() => {
        const loadBMapCss = async () => {
            await loadCss(cssUrl || _cssUrl);
        };
        loadBMapCss();
    }, []);
    useEffect(() => {
        const getBMapKeyToSrc = async () => {
            const key = mode
                ? '6X7yXzcGlAjLTTPTAnkyIGpx3OcBg9H1'
                : await getEnvKey('BAIDU_MAP_KEY', mode, authLoginType);
            setSrc(`//api.map.baidu.com/getscript?type=webgl&v=1.0&ak=${key}&services=&t=${new Date().valueOf()}`);
        };
        if (url) {
            setSrc(url);
        }
        else {
            getBMapKeyToSrc();
        }
    }, [url]);
    return status;
}
